import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  id: "photos_title_banner_component",
  class: "text-white mt-2"
}
const _hoisted_2 = {
  id: "photos-content-row",
  class: "text-center position-relative"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  class: "alert alert-info mt-4 fs-6 fw-bold pt-2 pb-2 w-50 margins-left-right-auto align-middle d-flex justify-content-center align-items-center",
  role: "alert"
}
const _hoisted_5 = { class: "ms-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PhotoListHome = _resolveComponent("PhotoListHome")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_PhotoListHome, {
        photos: _ctx.photos,
        isLoading: _ctx.apiStatus === _ctx.STATUS_API_CALL.RUNNING
      }, null, 8, ["photos", "isLoading"]),
      (_ctx.apiStatus === _ctx.STATUS_API_CALL.RUNNING && _ctx.photos.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[0] || (_cache[0] = _createElementVNode("span", {
                class: "spinner-border text-info fw-bold",
                role: "status"
              }, null, -1)),
              _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.languageStore.text(_ctx.TEXT_KEYS.PHOTO_RESULTS_LOADING_PHOTO)), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}